import axios from "axios"
import { ApiUrl } from "../utils/network"

export async function getComments(
    gameId: string,
    userId: string = "",
    parentCommentId: string = "",
    sortField: string = "Id",
    sortDirection: number = -1,
    page: number = 1,
    limit: number = 20
) {
    const url = `${ApiUrl}/api/v1/game-comments`

    return axios.get(url, {
        params: {
            performer: userId,
            parent: parentCommentId,
            game: gameId,
            orderBy: sortField,
            order: sortDirection,
            page: page,
            limit: limit
        }
    })
}

export async function createComment(gameId: string, content: string, parentCommentId: string = "") {
    const url = `${ApiUrl}/api/v1/game-comments`

    const payload = {
        game: gameId,
        content: content,
        parent: parentCommentId
    }

    return axios.post(url, payload)
}

export async function interactComment(commentId: string, type: number) {
    const url = `${ApiUrl}/api/v1/game-likes`

    const payload = {
        commentId: commentId,
        action: type
    }

    return axios.post(url, payload)
}

export async function deleteInteractComment(commentId: string) {
    const url = `${ApiUrl}/api/v1/game-likes/${commentId}`

    return axios.delete(url)
}
